export default{
    GET_ALL_USER_DETAILS(state, payload){
        state[payload.key] = payload.value;
    },

    SET_SEGMENT_TYPE_DETAILS(state, payload){
        state[payload.key] = payload.value;
    },

    SET_SEGMENT_DETAILS(state, payload){
        state[payload.key] = payload.value;
    },

    GET_ALL_SEGMENT_TYPES(state, payload){
        state[payload.key] = payload.value;
    },

    GET_ALL_SEGMENT(state, payload){
        state[payload.key] = payload.value;
    },

    ADD_NEW_ENTITY(state, payload){
        state[payload.key] = payload.value;
    },

    ONE_SEGMENT(state, payload){
        state[payload.key] = payload.value;
        // oneSegment=payload;
    },

    DELETE_AUDIENCE(state, payload){
        state[payload.key] = payload.value;
    },

    UPDATE_ONE_DETAILS(state, payload){
        state[payload.key] = payload.value;
    },

    UPDATE_AUDIENCE(state, payload){
        state[payload.key] = payload.value;
    },
}